import React from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import { Container, Wrapper, ImageWrapper } from '@components/Internship/Partners/styles';

import TextHeader, { SIZE, TAG, WEIGHT } from '@components/TextHeader';
import Partners2025 from '@assets/images/partnerzy-2026.png';

function Partners() {
  const { t } = useTranslation('internship');
  return (
    <Container className="partners">
      <Wrapper>
        <TextHeader size={SIZE.LG} weight={WEIGHT.NORMAL} tag={TAG.H2}>
          {t('Partners')}
        </TextHeader>
        <ImageWrapper>
          <Image src={Partners2025} />
        </ImageWrapper>
      </Wrapper>
    </Container>
  );
}

export default Partners;
